export var FAVOURITE_LARGE_SIZE = 44;
export var FAVOURITE_LARGE_PRESS_SIZE = FAVOURITE_LARGE_SIZE - 4;
export var FAVOURITE_SMALL_SIZE = 32;
export var FAVOURITE_SMALL_PRESS_SIZE = FAVOURITE_SMALL_SIZE - 4;